<div class="filter-header" (click)="closeAll()">
  <!-- LEFT SIDE -->
  <div class="left-section">
    <!-- SEARCH -->
    <div class="search-container">
      <div class="search-input-wrapper">
        <div class="search-40-wrapper">
          <wm-common-textfield
            class="search-field1"
            [data]="searchFieldConfig"
            [(ngModel)]="searchQuery"
            (ngModelChange)="handleSearchChange($event)"
          >
          </wm-common-textfield>
        </div>

        <div class="advanced-dropdown" *ngIf="isAdvancedOpen">
          <wm-common-text
            [data]="{
          text: 'Advanced Search',
          fontFamily: 'roboto',
          fontSize: '12px',
          fontWeight: '600',
          color: '#000000',
        }"
          ></wm-common-text>

          <wm-common-textfield
            [data]="{
          label: 'Parcel ID',
          value: formData.ParcelId,
        }"
            (valueChange)="onParcelIdChange($event)"
          ></wm-common-textfield>
          <wm-common-textfield
            [data]="{
          label: 'Property Owner',
          value: formData.PropertyOwner,
        }"
            (valueChange)="onPropertyOwnerChange($event)"
          ></wm-common-textfield>
          <wm-common-textfield
            [data]="{
          label: 'Property Address',
          value: formData.PropertyAddress,
        }"
            (valueChange)="onPropertyAddressChange($event)"
          ></wm-common-textfield>

          <div class="btn-area">
            <div class="save-btn">
              <wm-common-button
                [data]="{
                text: 'SEARCH',
                onClick: onAdvancedSearch.bind(this,'Parcel')
              }"
              ></wm-common-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BUTTONS -->
    <div class="button-row">
      <!-- added by priya 27-02-2026 -->
      <!-- Added by Amisha on 2026-07-17.
           Reason: contractor registrations reuse this shared filter builder, so the attribute
           popover needs a hook for contractor-only overflow and placement styling. -->
      <ng-template #filterPopover>
        <div
          class="attribute-dropdown"
          [style.max-height.px]="dropdownMaxHeight"
        >
          <ul class="list-group new-layout">
            <li
              class="list-group-item filter-item"
              style="cursor: pointer;"
              *ngFor="let item of filteredParams"
              (click)="addFilter(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </ng-template>
      <ng-container *ngIf="!hideAttributeButton">
        <a
          #filterBtn
          type="button"
          class="new-layout-filter-btn"
          [ngbPopover]="filterPopover"
          [popoverClass]="attributePopoverClass"
          #fp="ngbPopover"
          (click)="
            isMobileView ? openMobileFilterDrawer('attribute') : showFilters(fp)
          "
          (hidden)="restoreMainContainerHeight()"
          [autoClose]="'outside'"
          triggers="manual"
          container="body"
        >
          <span class="material-icons dropdown-icon">
            filter_alt
          </span>
          ATTRIBUTE
          <span class="material-icons dropdown-icon">
            keyboard_arrow_down
          </span>
        </a>
      </ng-container>
      <!-- end by priya 27-02-2026 -->

      <!-- MY WORK -->
      <!-- Code added by Sanchit Start 02/24/2026 -->
      <div
        class="blue-btn clickable new-layout-filter-btn"
        [matMenuTriggerFor]="!isMobileView ? myWorkMenu : null"
        (click)="
          isMobileView ? openMobileFilterDrawer('mywork') : styleMyWork()
        "
      >
        <mat-icon class="dropdown-icon">filter_alt</mat-icon>
        <span>MY WORK</span>
        <mat-icon class="arrow dropdown-icon">keyboard_arrow_down</mat-icon>
      </div>

      <mat-menu #myWorkMenu="matMenu" yPosition="below" xPosition="after">
        <button
          mat-menu-item
          *ngFor="let option of myWorkOptions"
          (click)="onMyWork(option); closeMobileFilterDrawer()"
          [class.my-work-selected]="isMyWorkSelected(option)"
        >
          {{ option?.name }}
        </button>
      </mat-menu>

      <!-- Custom Buttons -->
      <div class="exports-right">
        <ng-template [ngTemplateOutlet]="customTemplate"></ng-template>
      </div>
    </div>
  </div>
</div>
<!-- added by priya 27-02-2026 -->

<!-- <div *ngIf="showFilterBuilder" class="filter-builder"> -->
<div
  *ngIf="(filters?.length || externalFilterInputs?.length) && showFilterBuilder"
  class="filter-builder"
>
  <span *ngFor="let filter of filters">
    <ng-template #popContent>
      <div
        *ngFor="let type of getFilterTypes(filter.param)"
        class="new-layout-div"
      >
        <div
          class="form-check"
          [ngClass]="useMuiLayout ? 'position-container' : null"
        >
          <input
            class="form-check-input"
            type="radio"
            name="queryType"
            [id]="type.name"
            [value]="type.name"
            (change)="changeFilterType(filter)"
            [(ngModel)]="filter.queryType"
          />
          <label class="form-check-label" [for]="type.name">
            {{ type.name }}
          </label>
        </div>
        <div class="md-form search-form" *ngIf="filter.queryType === type.name">
          <div
            class="selected-value"
            *ngIf="
              (filter.queryType === 'is' || filter.queryType === 'is not') &&
              filter.param.options
            "
            (click)="toggleOptionMenu()"
            style="cursor: pointer;"
          >
            {{ getSelectedOptionName(filter) || 'Select Option' }}
            <div
              *ngIf="openOptionMenu"
              class="nested-menu-options"
              [style.max-height.px]="dropdownHeight"
            >
              <div
                class="menu-item"
                *ngFor="let opt of getFilterOptions(filter.param)"
                [class.active]="filter.value === opt.value"
                (mousedown)="
                  onOptionSelect(filter, opt); $event.stopPropagation()
                "
              >
                {{ opt.name }}
              </div>
              <input
                type="hidden"
                [name]="type.name + '-input'"
                [(ngModel)]="filter.value"
              />
            </div>
          </div>

          <div
            class="selected-value"
            *ngIf="
              (filter.queryType === 'in' || filter.queryType === 'in not') &&
              filter.param.options
            "
            (click)="toggleOptionMenu()"
            style="cursor: pointer;"
          >
            {{ getSelectedOptionInQuery(filter) || 'Select Option' }}
            <div
              *ngIf="openOptionMenu"
              class="nested-menu-options"
              [style.max-height.px]="dropdownHeight"
            >
              <div
                class="menu-item"
                *ngFor="let opt of getFilterOptions(filter.param)"
                [class.active]="isSelected(filter, opt.value)"
                (click)="
                  onOptionInSelect(filter, opt);
                  $event.stopPropagation();
                  $event.preventDefault()
                "
              >
                {{ opt.name }}
              </div>
            </div>
          </div>

          <div *ngIf="!filter.param.options && filter.queryType === 'in'">
            <input
              [type]="filter.param.inputType || 'text'"
              class="form-control"
              [name]="type.name + '-input'"
              placeholder=""
              [attr.aria-describedby]="type.name + '-inputHelp'"
              (ngModelChange)="filtersChanged()"
              [(ngModel)]="filter.value"
            />
            <small [id]="type.name + '-inputHelp'" class="form-text text-muted"
              >Enter a comma separated list of items to search by.</small
            >
          </div>

          <ng-container *ngIf="filter.queryType === 'range'">
            <!-- trigger / selected display -->
            <div
              class="selected-value"
              *ngIf="
                filter.queryType === 'range' &&
                filter.param.inputType === 'date'
              "
              (click)="toggleRangeMenu()"
              style="cursor: pointer;"
            >
              {{ getSelectedRangeName(filter) || 'Select range' }}
            </div>

            <!-- dropdown -->
            <div
              *ngIf="openRangeMenu"
              class="nested-menu-options"
              [style.max-height.px]="dropdownHeight"
            >
              <div
                class="menu-item"
                *ngFor="let opt of getFilterRangeOptions(filter.param)"
                [class.active]="filter.value === opt.value"
                (mousedown)="
                  onDateRangeSelect(filter, opt); $event.stopPropagation()
                "
              >
                {{ opt.name }}
              </div>

              <input
                type="hidden"
                [name]="type.name + '-input'"
                [(ngModel)]="filter.value"
              />
            </div>

            <ng-container
              *ngIf="
                filter.value === 'custom' ||
                filter.param.inputType === 'text' ||
                filter.param.inputType === 'number'
              "
            >
              <div class="form-group">
                <label [for]="type.name + '-custom-input-start'"></label>
                <input
                  [type]="filter.param.inputType"
                  class="form-control"
                  [name]="type.name + '-custom-input-start'"
                  placeholder=""
                  (ngModelChange)="filtersChanged()"
                  [(ngModel)]="filter.customValue.start"
                  *ngIf="(filter.param.options || []).length === 0"
                />
              </div>
              <select
                *ngIf="(filter.param.options || []).length !== 0"
                class="form-control"
                [name]="type.name + '-custom-input-start'"
                (ngModelChange)="filtersChanged()"
                [(ngModel)]="filter.customValue.start"
              >
                <option></option>
                <option
                  *ngFor="let o of filter.param.options"
                  [value]="o.value"
                >
                  {{ o.name }}
                </option>
              </select>

              <div class="form-group">
                <label [for]="type.name + '-custom-input-end'"></label>
                <input
                  [type]="filter.param.inputType"
                  class="form-control"
                  [name]="type.name + '-custom-input-end'"
                  placeholder=""
                  (ngModelChange)="filtersChanged()"
                  [(ngModel)]="filter.customValue.end"
                  *ngIf="(filter.param.options || []).length === 0"
                />
                <select
                  *ngIf="(filter.param.options || []).length !== 0"
                  class="form-control"
                  [name]="type.name + '-custom-input-end'"
                  (ngModelChange)="filtersChanged()"
                  [(ngModel)]="filter.customValue.end"
                >
                  <option></option>
                  <option
                    *ngFor="let o of filter.param.options"
                    [value]="o.value"
                  >
                    {{ o.name }}
                  </option>
                </select>
              </div>
            </ng-container>
          </ng-container>

          <input
            *ngIf="
              (!filter.param.options || filter.queryType === 'contains') &&
              filter.queryType !== 'range' &&
              filter.queryType !== 'in' &&
              filter.queryType !== 'exists' &&
              filter.queryType !== 'not exists'
            "
            [type]="filter.param.inputType || 'text'"
            class="form-control"
            [name]="type.name + '-input'"
            placeholder=""
            (ngModelChange)="filtersChanged()"
            [(ngModel)]="filter.value"
          />
        </div>
      </div>
      <div class="button-content">
        <button type="button" class="done-button" (click)="p.close()">
          Done
        </button>
      </div>
    </ng-template>

    <div
      #chipEl
      class="chip chip-mui"
      [class.simu-layout]="useMuiLayout"
      [autoClose]="'outside'"
      triggers="manual"
      #p="ngbPopover"
      (click)="openFilter(p, chipEl)"
      #popovers="ngbPopover"
      [ngbPopover]="popContent"
      container="body"
      placement="bottom"
      [id]="'filter-' + filter.id"
      [popoverClass]="
        useMuiLayout
          ? 'mui-popover ' +
            (['in', 'is', 'range'].includes(
              (filter?.queryType || '').toLowerCase()
            )
              ? 'popover-in-layout'
              : '')
          : ''
      "
    >
      <wm-common-text
        class="filter-text"
        [data]="{ text: filter.param.name + ' ' + filterText(filter) }"
      ></wm-common-text>
      <wm-common-icon
        class="close-icon"
        [data]="{ iconName: 'close' }"
        (click)="removeFilter(filter); $event.stopPropagation()"
      ></wm-common-icon>
    </div>
  </span>
  <!-- </div> -->
  <!-- end by priya 27-02-2026 -->

  <!-- added by Sanchit 02-03-2026 -->
  <!-- FILTER CHIPS -->
  <!-- <div *ngIf="externalFilterInputs?.length > 0" class="filter-builder"> -->
  <div class="chip chip-mui" *ngFor="let item of externalFilterInputs">
    <!-- <wm-common-text
      class="filter-text"
      [data]="{ text: item.title }"
    >
    </wm-common-text>

    <wm-common-text
      class="filter-selected"
      [data]="{ text: item.options[0].searchText }"
    >
    </wm-common-text> -->

    <!-- MY WORK CHIP -->
    <ng-container *ngIf="isMyWorkChip(item); else attributeChip">
      <wm-common-text
        class="filter-text"
        [data]="{ text: getMyWorkLabel(item) }"
      ></wm-common-text>
    </ng-container>

    <!-- ParcelId CHIP -->
    <ng-template #attributeChip>
      <wm-common-text
        class="filter-text"
        [data]="{ text: item.title }"
      ></wm-common-text>

      <wm-common-text
        class="filter-selected"
        [data]="{ text: item.options[0]?.searchText }"
      ></wm-common-text>
    </ng-template>

    <wm-common-icon
      class="close-icon"
      [data]="{ iconName: 'close' }"
      (click)="onFilterChipRemove(item)"
    >
    </wm-common-icon>
  </div>
</div>
<!-- end by Sanchit 02-03-2026 -->
<!-- end by Sanchit 02-03-2026 -->

<!-- MOBILE DRAWER -->
<div
  *ngIf="isFilterDrawerOpen"
  #mobileFilterDrawer
  class="mobile-drawer-overlay"
  (click)="closeMobileFilterDrawer()"
>
  <div
    class="mobile-drawer-card"
    (click)="$event.stopPropagation()"
  >
    <!-- HEADER -->
    <div class="mobile-drawer-header">
      <div class="mobile-drawer-title">
        {{ filterDrawerType === 'attribute' ? 'Attribute' : 'My Work' }}
      </div>

      <div class="mobile-drawer-close" (click)="closeMobileFilterDrawer()">
        <mat-icon>close</mat-icon>
      </div>
    </div>

    <!-- BODY -->
    <div class="mobile-drawer-body">
      <!-- ATTRIBUTE -->
      <ng-container *ngIf="filterDrawerType === 'attribute'">
        <div
          class="mobile-drawer-item"
          *ngFor="let item of filteredParams"
          (click)="addFilter(item); closeMobileFilterDrawer()"
        >
          {{ item.name }}
        </div>
      </ng-container>

      <!-- MY WORK -->
      <ng-container *ngIf="filterDrawerType === 'mywork'">
        <div
          class="mobile-drawer-item"
          *ngFor="let option of myWorkOptions"
          (click)="onMyWork(option); closeMobileFilterDrawer()"
        >
          {{ option.name }}
        </div>
      </ng-container>
    </div>
  </div>
</div>
